// patient.js

import { RESET_PATIENT, SET_PATIENT, GET_PATIENTS, FETCHING_LIST, SET_PATIENT_FORM, SET_ERROR, RESET_ERROR } from '../reducers/patient';
import { callApiWithB2CToken } from './callApi';
import { msalConfig, tokenRequest, getPatientListUrl, patientUrl } from '../config-client';

const Msal = require('msal');

const myMSALObj = new Msal.UserAgentApplication(msalConfig);

// set the active patient resource
export const setActive = patient => (dispatch) => {
  dispatch({
    type: SET_PATIENT,
    payload: patient,
  });
};

// get a list of patients, this is only available for the clinician version of the app
export const getList = () => {
  const url = getPatientListUrl;
  return (dispatch) => {
    dispatch({ type: FETCHING_LIST });
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse =>
        callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'GET')
          .then((response) => {
            // if the response is an error then send an error message as the payload
            if (response.status !== 200 && response.status !== 201) {
              dispatch({ type: SET_ERROR, payload: '' });
            } else {
              dispatch({ type: SET_ERROR, payload: 'no error' });
            }
            return response.json();
          })
          .then(json => dispatch({ type: GET_PATIENTS, payload: json }))
          .catch(error => dispatch({ type: GET_PATIENTS, payload: error })));
  };
};

// submit the edited or new patient resource
// this is used by the PatientEdit.js/PatientForm.js components to POST/PUT the edited patient details form
export const submitPatient = (responseObject) => {
  const url = patientUrl;
  return (dispatch) => {
    dispatch({ type: SET_PATIENT });
    const headers = new Headers();
    const body = JSON.stringify(responseObject);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return myMSALObj.acquireTokenSilent(tokenRequest)
      .then(tokenResponse => callApiWithB2CToken(url, tokenResponse.accessToken, headers, 'POST', body)
        .then((response) => {
          // if the response is an error then send an error message as the payload
          if (response.status !== 200 && response.status !== 201) {
            dispatch({ type: SET_ERROR, payload: '' });
          } else {
            dispatch({ type: SET_ERROR, payload: 'no error' });
          }
          return response.json();
        }))
      .then(json => dispatch({ type: SET_PATIENT, payload: json }))
      .catch(error => dispatch({ type: SET_PATIENT, payload: error }));
  };
};

// reset the patient object in redux, in clinician version this happens in /PatientList
// since the clinician can select another patient
export const resetPatient = () => (dispatch) => {
  dispatch({
    type: RESET_PATIENT,
    payload: null,
  });
};

// this is store the form object (which is different to the patient resource object)
// once a patient resource is active, this needs to happen to repopulate the Patient Edit form
export const loadForm = responseObject => (dispatch) => {
  dispatch({
    type: SET_PATIENT_FORM,
    payload: responseObject,
  });
};

// reset the error message once the page is reloaded
export const resetPatientError = () => (dispatch) => {
  dispatch({
    type: RESET_ERROR,
    payload: null,
  });
};



// WEBPACK FOOTER //
// ./src/actions/patient.js